<template>
	<div v-title="'世界答题-圣斗士星矢-腾讯游戏'" class="daily-question">
		<div id="wraper">
			<section class="page page1">
				<div class="flash">
					<div id="swfcontent">
					</div>
				</div>
				<a class="btn" @click="getReward"></a>

				<span class="pa nickname" v-if="isBind">{{characName}} <a style="color:#f00;display: inline;"@click="reBinding">[重新绑定]</a></span>
				<a v-else class="center relogin" @click="reBinding"></a>
			</section>
			<transition name="fade">
				<div class="mark" v-if="rewardMsg">
					<div class="alertbox">
						<div class="pa txt">{{rewardItem.title}}</div>
						<a class="okbtn" @click="rewardMsg = false"></a>
						<a class="toGame" href="http://seiya.qq.com/cp/a20180307ou/play.html"></a>
					</div>
				</div>
			</transition>

		</div>
		<div class="vspromps" id="vspromps">
			<div class="vspromps-box">
				<div class="vspromps-pic"><i></i></div><span>为了更好的体验，请将手机/平板竖过来</span>
			</div>
		</div>
	</div>
</template>

<script>
	import wxMethods from '@/utils/wxMethods'
	import mtaInitial from '@/utils/mtaInitial'
	import Http from '@/utils/Http'

	export default {
		name: 'DailyQuestion',

		mixins: [wxMethods],

		data() {
			return {
				isBind: false,
				bindDialog: false,
				bindMsg: false,
				characName: '',
				rewardMsg: false,
				rewardItem: {},
				repeatMsg: false,
				isCheck: false,
				loading: false,
			}
		},

		created() {
			this.wxHideMenu()
			this.getRole()
		},

		mounted() {
			//屏幕适应
			var zoom = 1
			zoom = document.body.clientWidth / 640;
			$('#wraper').css('zoom', zoom)
			this.SWFOBJ = new mo.Lottery({
					'r': 8,
					'width': 532,
					'height': 532,
					'flashFirst': false,
					'b': require('@/assets/ossweb-img/lottery.png'),
					's': require('@/assets/ossweb-img/circle.png'),
					'bx': 0,
					'by': 0,
					'sx': 0,
					'sy': 400,
					'contentId': 'swfcontent', //嵌入swf 的div层的 id 
					// 'onClickRollEvent': this.getReward,
					'onCompleteRollEvent': this.callJsToComplete,
				});
			mtaInitial(process.env.VUE_APP_MTA_DAYLY_SID, process.env.VUE_APP_MTA_DAYLY_CID)
		},

		methods: {
			roll(id) {
				if (this.SWFOBJ) {
					this.SWFOBJ.stopRoll(id);
				}
			},
			callJsToComplete(){
				var that = this
				setTimeout(function() {
					that.rewardMsg = true
					that.loading = false
					that.isCheck = true
				}, 500);
			},
			getRole() {
				if(this.loading){
					return
				}
				var that = this
				GameTools.getRole(process.env.VUE_APP_GAME)
					.then((res) => {
						if (res.hasRole) {
							that.checkReward()
							that.characName = res.roleInfo.charac_name
							that.isBind = true
						} else {
							const modal = new GameModal({
								game: process.env.VUE_APP_GAME,
								serverSelect: res.serverSelect,
								confirmText: ' ',
								showClose: true,
							})

							modal.show()
							var zoom = 1
							zoom = document.body.clientWidth / 640;
							$('.game-tools-modal').css('zoom', zoom)
							modal.afterBind = (isBinded, characName) => {
								if (isBinded) {
									console.log(characName)
									alert('绑定成功！')
									that.isBind = true
									that.characName = characName
									modal.hide()
								}
							}
						}
					})
			},
			// 重新绑定角色
			reBinding() {
				if(this.loading){
					return
				}
				var that = this
				GameTools.getServerSelect(process.env.VUE_APP_GAME)
					.then((serverSelect) => {
						const modal = new GameModal({
							game: process.env.VUE_APP_GAME,
							serverSelect,
							confirmText: ' ',
							showClose: true
						})
						modal.show()
						var zoom = 1
						zoom = document.body.clientWidth / 640;
						$('.game-tools-modal').css('zoom', zoom)
						modal.afterBind = function(isBinded, characName) {
							if (isBinded) {
								alert('绑定成功！')
								modal.hide()
								that.characName = characName
								that.isBind = true
							}
						}
					})
			},
			/**
			 * 查询抽奖资格接口
			 */
			checkReward() {
				var that = this
				Http.post({
						path: 'daily_qa/reward/valid',
						params: {
							game: process.env.VUE_APP_GAME
						},
					})
					.then((res) => {
						console.info('success', res)
						if(res.code == 403){
							that.isCheck = true
						}
					})
					.catch((err) => {
						alert(err.msg)
					})
			},
			// 领奖
			getReward() {
				if (this.loading) {
					return
				} else {
					var that = this
					if (this.isBind) {
						this.loading = true
						Http.post({
								path: 'daily_qa/reward/get',
								params: {
									game: process.env.VUE_APP_GAME
								},
							})
							.then((res) => {
								if (res.code == 200) {
									that.rewardItem = that.getRewardPic(res.result.package_id)
									that.roll(that.rewardItem.luckyId)
								} else {
									alert(res.msg)
									that.loading = false
								}
							})
							.catch((err) => {
								alert(err.msg)
								that.loading = false
							})
					} else {
						this.getRole()
					}
				}
			},
			// 礼包图片匹配
			getRewardPic(id){
				var obj = {
					luckyId:null,
					title:''
				}
				switch(id){
					case '1107873':
						obj.title = '高级星石*10'
						obj.luckyId = 7
						break;
					case '1107874':
						obj.title = '技能魔典碎片*1'
						obj.luckyId = 3
						break;
					case '1107875':
						obj.title = '珍品都是碎片宝箱*1'
						obj.luckyId = 4
						break;
					case '1107876':
						obj.title = '高级星石*1'
						obj.luckyId = 2
						break;
					case '1107877':
						obj.title = '中阶觉醒石*2'
						obj.luckyId = 1
						break;
					case '1107878':
						obj.title = 'SS小宇宙礼盒*1'
						obj.luckyId = 0
						break;
					case '1107879':
						obj.title = '皮肤券*10'
						obj.luckyId = 6
						break;
					case '1107872':
						obj.title = '斗士经验*20000'
						obj.luckyId = 5
						break;
				}
				return obj
			},
		},
	}
</script>

<style src="./DailyQuestion.scss" lang="scss"></style>
